<div class="flex">

  <div class="flex flex-col flex-1 gap-4">
    @if (completedAt()) {
      <elcia-badge [tone]="'success'" class="self-start">
        {{ 'todo.completed-at' | translate }} {{ completedAt() | date: 'dd/MM/yyyy HH:mm' }}
      </elcia-badge>
    }

    <div class="flex gap-2">
      <div class="flex h-10 shrink-0 items-center">
        <elcia-check-box [control]="todoForm.controls.isDone"/>
      </div>
      <div class="w-full">
        <elcia-text-input [control]="todoForm.controls.title" [label]="'todo.title' | translate"/>
      </div>
      <div class="w-1/5">
        <elcia-date-picker [control]="todoForm.controls.dueDate" [label]="'todo.due-date' | translate"/>
      </div>
      @if (isAuthor()) {
        <div class="w-auto">
          <elcia-toggle-todo-private [control]="todoForm.controls.isPrivate"/>
        </div>
      }
    </div>

    <elcia-text-area [control]="todoForm.controls.description" [label]="'todo.description' | translate" [rows]="3"/>

    <div class="flex gap-2">
      <div class="w-1/3">
        <elcia-party-dropdown [control]="todoForm.controls.concernId" [partyTypes]="partyTypes()"/>
      </div>
      <div class="w-1/3">
        <elcia-todo-priority-dropdown [control]="todoForm.controls.priorityName"/>
      </div>
      <div class="w-1/3">
        <elcia-todo-status-dropdown [control]="todoForm.controls.statusId"/>
      </div>

    </div>
    <div class="flex gap-2">
      <div class="w-2/3">
        <elcia-user-dropdown [control]="todoForm.controls.assignedToIds" [isMulti]="true" [label]="'assigned'"/>
      </div>
      <div class="w-1/3">
        <elcia-numeric-input [control]="todoForm.controls.estimatedTimeInDays"
                             [label]="'todo.estimated-time-in-days' | translate"
                             [minFractionDigits]="1"/>
      </div>
    </div>

    <elcia-document-uploader
      (onDelete)="markForDeletion($event)"
      (onDownload)="downloadDocument($event)"
      (onFilesSelected)="addPendingFiles($event)"
      (onRemovePendingFile)="removePendingFile($event)"
      [documents]="displayedDocuments()"
      [pendingFiles]="pendingFiles()"
    />

    <p-divider/>

    <div class="flex flex-col gap-4 pt-10">
      <elcia-label [label]="'entity.sub-todos' | translate"/>
      <div class="flex py-2 flex-col gap-4 max-h-96 overflow-y-auto">
        @for (child of this.todoForm.controls.children.controls; track $index) {


          <div (focusout)="ensureTrailingRow()"
               class="{{$last ? 'p-3 rounded-xl border border-primary-50 bg-[var(--p-surface-50)]' : ''}}">

            <elcia-sub-todo-form (onRemove)="removeChild($index)" [control]="child"/>
          </div>
        }
      </div>
    </div>

  </div>
  @if (this.initialValue()?.id) {

    <p-divider layout="vertical"/>
    <div class="flex flex-col w-1/3">
      <div class="flex gap-2 px-2 pb-3">
        <elcia-button (onClick)="rightPanel.set('chat')"
                      [label]="'app.comments' | translate"
                      [severity]="rightPanel() === 'chat' ? 'primary' : 'secondary'"/>
        <elcia-button (onClick)="rightPanel.set('timesheets')"
                      [label]="'entity.timesheets' | translate"
                      [severity]="rightPanel() === 'timesheets' ? 'primary' : 'secondary'"/>
      </div>

      @if (rightPanel() === 'chat') {
        <elcia-todo-comment [localTodos]="localTodos()" [storeTodos]="storeTodos()" [todoId]="this.initialValue()!.id!"
                            [users]="users()"/>
      } @else {
        <elcia-todo-timesheet-list [todoIds]="linkedTodoIds()"/>
      }
    </div>
  }
</div>
